import React, {useContext, useEffect, useState} from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";

import Filter from "./LeftFilter/Filter";
import ApplicationsTable from "./ApplicationsTable/ApplicationsTable";
import {OAuthContext} from "../../context/OAuthContext";
import {UserContext} from "../../context/UserContext";
import {ApplicationsTableContext} from "../../context/ApplicationsTableContext";
import RequestResultSnackbar from "./RequestResultSnackbar/RequestResultSnackbar";
import PageLayout from "../../layout/PageLayout";
import {checkIfTokenExpired} from "./utils";
import {useTranslation} from "react-i18next";

const Home = () => {
    const {errorOauth, oauthData} = useContext(OAuthContext);
    const {errorApplicationsTable, setErrorApplicationsTable} = useContext(ApplicationsTableContext);
    const {errorUser, setErrorUser} = useContext(UserContext);
    const isTokenExpired = oauthData?.isTokenExpired();

    const { t } = useTranslation("common");

    const [isTokenExpireSnackbar, setIsTokenExpireSnackbar] = useState<{ open: boolean, message: string}>({ open: false, message: ""})

    useEffect(() => {
        if(checkIfTokenExpired(oauthData, isTokenExpired)){
            setIsTokenExpireSnackbar(prevState => ({...prevState, open: true, message: t("token_expired")}))
        }
    }, [oauthData,isTokenExpired, t])

    const handleCloseError = () => {
        setErrorApplicationsTable(prevState => ({...prevState, error: false}))
        setErrorUser(prevState => ({...prevState, error: false}))
    }

    return <PageLayout>
        {!errorOauth.error ?
            <Grid container spacing={3}>
                <Grid item xs={2}>
                    <Filter/>
                </Grid>
                <Grid item xs={10}>
                    <ApplicationsTable/>
                </Grid>
            </Grid>
            : <Alert severity="error"><Typography>{errorOauth.message}</Typography></Alert>}

        {errorApplicationsTable.error || errorUser.error ?
            <RequestResultSnackbar anchorOrigin={{vertical: "top", horizontal: "right"}}
                                   open={errorApplicationsTable.error ?? errorUser.error} onClose={handleCloseError}
                                   autoHideDuration={3000} status="error"
                                   message={errorApplicationsTable.message ?? errorUser.message}/> : null}
        <RequestResultSnackbar anchorOrigin={{vertical: "top", horizontal: "right"}} open={isTokenExpireSnackbar.open}
                               onClose={() => setIsTokenExpireSnackbar(prevState => ({...prevState, open: false}))} autoHideDuration={3000} status="error"
                               message={isTokenExpireSnackbar.message}/>


    </PageLayout>
}

export default Home;